import React from "react";
import { useTranslation } from "react-i18next";
import { Outlet } from "react-router-dom";
import NestedTabsComponent from "../nested-tabs-component";
import { ACCESS_CONFIG, EVALUATION_TYPE, NESTED_SIDENAV } from "../strings";

const FunnelsEvaluation = () => {
  const { t } = useTranslation();
  const { ADMIN_TIER } = ACCESS_CONFIG;
  return (
    <div className="d-flex h-100">
      <div className="sub-sidebar">
        <div className="inner-sub-sidebar">
          <div className="tab-heading ps-3 mt-4">{t("funnelsEvaluation")}</div>
          <NestedTabsComponent
            nestedNavType={NESTED_SIDENAV.EVALUATION}
            clearParams
            tabs={[
              {
                evKey: EVALUATION_TYPE.OVERVIEW,
                title: "Overview",
                access: ADMIN_TIER
              },
              {
                evKey: EVALUATION_TYPE.INSIGHTS,
                title: "Insights",
                access: ADMIN_TIER
              },
              {
                evKey: EVALUATION_TYPE.OPTIMIZATION,
                title: "Optimization",
                access: ADMIN_TIER
              },
              {
                evKey: EVALUATION_TYPE.ZIP_CHECK,
                title: "Zip Checking",
                access: ADMIN_TIER
              }
              // {
              //   evKey: EVALUATION_TYPE.EXPORT_QUERIES,
              //   title: "Export Queries"
              // }
            ]}
          />
        </div>
      </div>
      <div className="outlet-wrapper">
        <Outlet />
      </div>
    </div>
  );
};
export default FunnelsEvaluation;
